/**
 * @generated SignedSource<<17a692f537b5baff57367252a4f1fcc0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FileScreenDeleteMutation$variables = {
  id: string;
};
export type FileScreenDeleteMutation$data = {
  readonly file: {
    readonly delete: boolean;
  };
};
export type FileScreenDeleteMutation = {
  response: FileScreenDeleteMutation$data;
  variables: FileScreenDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "FileMutation",
    "kind": "LinkedField",
    "name": "file",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "delete",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FileScreenDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FileScreenDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6c7759ec9496de8f7db0b939d0162f02",
    "id": null,
    "metadata": {},
    "name": "FileScreenDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation FileScreenDeleteMutation(\n  $id: ID!\n) {\n  file(id: $id) {\n    delete\n  }\n}\n"
  }
};
})();

(node as any).hash = "657a6bc142cfba2ac79ecafa39921abb";

export default node;
